var React = require('react');

function PersonalFinanceBuyoutCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M75.1216 27.6215L34.0002 68.7429L16.8789 51.6215L21.1215 47.3789L34.0002 60.2576L70.8789 23.3789L75.1216 27.6215Z","fill":"black"}));
}

PersonalFinanceBuyoutCheck.defaultProps = {"width":"92","height":"93","viewBox":"0 0 92 93","fill":"none"};

module.exports = PersonalFinanceBuyoutCheck;

PersonalFinanceBuyoutCheck.default = PersonalFinanceBuyoutCheck;
